/**
 * Utilidades para desarrollo
 */

// Función para limpiar todos los datos del localStorage
export const clearAllData = () => {
  const keys = [
    'theaterAuth',
    'theaterUserCode', 
    'theaterUserData',
    'theaterEventData',
    'theaterConfig',
    'adminToken',
    'adminData',
    'theaterSessionStartTime'
  ];
  
  keys.forEach(key => localStorage.removeItem(key));
  
  // Recargar la página
  window.location.reload();
};

export const clearTheaterData = () => {
  const keys = [
    'theaterAuth',
    'theaterUserCode', 
    'theaterUserData',
    'theaterEventData',
    'theaterConfig',
    'theaterSessionStartTime'
  ];
  
  keys.forEach(key => localStorage.removeItem(key));
  
  // Recargar la página
  window.location.reload();
};

// Función para probar el flujo de carga
export const testLoadingFlow = () => {
  // Verificar estado inicial
  const state = window.store?.getState();
  
  // Verificar si debería mostrar LoadingScreen
  const shouldShowLoading = 
    state?.config?.loading || 
    !state?.config?.isInitialized || 
    state?.auth?.loading || 
    !state?.auth?.isInitialized;
    
  return {
    state,
    shouldShowLoading,
    localStorage: {
      theaterAuth: localStorage.getItem('theaterAuth'),
      theaterUserCode: localStorage.getItem('theaterUserCode'),
      theaterUserData: localStorage.getItem('theaterUserData'),
      theaterEventData: localStorage.getItem('theaterEventData'),
      theaterSessionStartTime: localStorage.getItem('theaterSessionStartTime'),
    }
  };
};

// Función para probar el timeout de sesión
export const testSessionTimeout = () => {
  const state = window.store?.getState();
  const auth = state?.auth;
  
  if (!auth) {
    return;
  }
  
  
  if (auth.sessionStartTime) {
    

  }
  
  return {
    auth,
    sessionInfo: auth.sessionStartTime ? {
      currentTime: Date.now(),
      timeElapsed: Date.now() - auth.sessionStartTime,
      remainingTime: auth.sessionTimeout - (Date.now() - auth.sessionStartTime),
      isExpired: (Date.now() - auth.sessionStartTime) > auth.sessionTimeout,
    } : null
  };
};

// Función para simular expiración de sesión (para testing)
export const simulateSessionExpiration = () => {
  const sessionStartTime = Date.now() - (11 * 60 * 1000); // 11 minutos atrás
  localStorage.setItem('theaterSessionStartTime', sessionStartTime.toString());
  
  return {
    sessionStartTime,
    timeElapsed: Date.now() - sessionStartTime,
    isExpired: true,
  };
};

// Función para simular expiración rápida (para testing)
export const simulateQuickExpiration = () => {
  const sessionStartTime = Date.now() - (10 * 60 * 1000 + 1000); // 10 minutos + 1 segundo atrás
  localStorage.setItem('theaterSessionStartTime', sessionStartTime.toString());
  
  return {
    sessionStartTime,
    timeElapsed: Date.now() - sessionStartTime,
    isExpired: true,
  };
};

// Función para monitorear el timer en tiempo real
export const monitorSessionTimer = () => {
  let monitorInterval;
  let startTime = Date.now();
  
  const monitor = () => {
    const state = window.store?.getState();
    const auth = state?.auth;
    
    if (!auth) {  
      return;
    }
    
    const sessionStartTime = auth.sessionStartTime;
    
    // Detectar si el timer se reinició
    if (sessionStartTime && sessionStartTime > startTime) {  
      startTime = sessionStartTime;
    }
  };
  
  // Monitorear cada 5 segundos
  monitorInterval = setInterval(monitor, 5000);
  
  // Mostrar estado inicial
  monitor();
  
  // Retornar función para detener monitoreo
  return () => {
    if (monitorInterval) {
      clearInterval(monitorInterval);
    }
  };
};

// Exponer funciones globalmente en desarrollo
if (process.env.NODE_ENV === 'development') {
  window.devUtils = {
    clearAllData,
    testLoadingFlow,
    testSessionTimeout,
    simulateSessionExpiration,
    simulateQuickExpiration,
    monitorSessionTimer
  };
  

} 